import {
  CursorPaginationSchema,
  api,
  apiEndpoint,
  cursorPaginatedResponse,
} from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { MediaAssetPreviewSchema } from "@apis/media/api";

import { GENERATION_SERVICE } from "../config/index.ts";
import { Generation } from "../models/index.ts";

export const GenerationPreviewSchema = z.object(
  { generation: Generation.schema, images: z.array(MediaAssetPreviewSchema) },
  {
    generation: "The generation",
    images: "The previews of the images the generation produced",
  },
);

export interface GenerationPreview
  extends z.infer<typeof GenerationPreviewSchema> {}

export const generationApi = api(
  { domain: API_DOMAIN, path: `${GENERATION_SERVICE.LABEL}/api` },
  {
    getGeneration: apiEndpoint({
      body: z.object(
        { id: Generation.shape.id },
        { id: Generation.descriptions.id },
      ),
      response: z.object(
        { generation: Generation.schema },
        { generation: "The generation" },
      ),
    }),
    getGenerations: apiEndpoint({
      body: CursorPaginationSchema,
      response: cursorPaginatedResponse(GenerationPreviewSchema),
    }),
  },
);
